export default __webpack_public_path__ + "static/media/flowering.37293c46.svg";